import { render } from "./shop-area.vue?vue&type=template&id=078c1c74&scoped=true"
import script from "./shop-area.vue?vue&type=script&lang=js"
export * from "./shop-area.vue?vue&type=script&lang=js"

import "./shop-area.vue?vue&type=style&index=0&id=078c1c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078c1c74"]])

export default __exports__